export default {
  REGULAR: 'regular',
  GALLERY: 'gallery',
  GALLERY_ITEM: 'gallery-item',
};
